module.exports = __webpack_public_path__ + "assets/img/tx110.64b8a456.jpg";